export default "__VITE_ASSET__CW8q2pfN__"